var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"id":"float_button"},on:{"click":function($event){_vm.linkOption !== null? _vm.$router.push(_vm.linkOption): _vm.onClick}}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }